import {
  EntryTypeCover,
  EntryTypeFree,
  EntryTypeFreeRSVP,
  EntryTypeRSVP,
  EntryTypeTicketed,
  EventFormatClass,
  EventFormatMarket,
  EventFormatNetworking,
  EventFormatParty,
  EventFormatPerformance,
  EventFormatPopup,
  EventFormatSports,
} from '@/lib/api/apiTypes';

export const STEPS = ['The pitch', 'When & where', 'Finish'] as const;
export const DEFAULT_EVENT_DURATION_MINUTES = 120;

export const ENTRY_TYPE_OPTIONS = [
  { value: EntryTypeFree, label: 'Free' },
  { value: EntryTypeCover, label: 'Cover charge' },
  { value: EntryTypeTicketed, label: 'Ticketed' },
  { value: EntryTypeRSVP, label: 'RSVP required' },
  { value: EntryTypeFreeRSVP, label: 'Free with RSVP' },
] as const;

export const EVENT_FORMAT_OPTIONS = [
  EventFormatParty,
  EventFormatPerformance,
  EventFormatNetworking,
  EventFormatClass,
  EventFormatPopup,
  EventFormatMarket,
  EventFormatSports,
] as const;

export const ATTIRE_PRESET_OPTIONS = ['Casual', 'Business Casual', 'Formal', 'Costume'] as const;

export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
] as const;
